/*
 * @Author: cjw 
 * @Date: 2021-03-30 08:35:43 
 * @Last Modified by: cjw
 * @Last Modified time: 2021-11-12 18:00:12
 */

/*
 * 提供跟踪数据修改功能
 *
 * 提供以下接口
 * 1. datas           用于编辑的对象数据
 * 1. getChanges()    获取修改日志
 * 2. getOriginal()   获取原值（即：修改前的值，提供字段原值，行原值，表原值）
 * 3. acceptChanges() 提交更改（提交自上次调用 acceptChanges 以来对该表进行的所有更改）
 * 4. rejectChanges() 撤消更改（拒绝自上次调用 acceptChanges 以来对该行进行的所有更改）
*/

// 是否对象
function isObject(obj) {
    return typeof obj === 'object' && obj !== null
}

// // 是否为数组的下标（索引）
// function isArrayIndex(obj) {
//     return /^\d+$/.test(obj)
// }

function getProxy(target, meta) {
    // 如果对象已有代理，则返回代理
    let observed = meta.toProxy.get(target)
    if (observed !== void 0) {
        return observed
    }

    if (meta.toRaw.get(target)) {
        return target
    }
}

// 初始化修改日志
function initChanges(meta) {
    meta.changes =  {
        added: [],
        deleted: [],
        modified: new WeakMap()
    }
}

// 清除数据，不记日志
function createClear(target, meta) {
    return function clear() {
        target.datas.length = 0
        meta.original.length = 0
        initChanges(meta)
    }
}

function createLoadDatas(target, meta) {
    return function loadDatas(datas) {
        target.datas.push(...datas)
        meta.original.push(...datas)
    }
}

// 提供获取原值
function createGetOriginal(meta) {
    return function getOriginal(target, name) {
        console.log(target, name)
        console.log(target, meta)
    }
}

// 获取修改日志
function createGetChanges(meta) {
    return function getChanges() {
        return meta.changes
    }
}

// 提交自上次调用 acceptChanges 以来对该表进行的所有更改
function createAcceptChanges(target, meta) {
    return function acceptChanges() {
        if (Array.isArray(target)) {
            // 实体调用
            initChanges(meta)
        } else {
            // 数据行调用
            meta.changes.modified.delete(target)
        }
    }
}

// 拒绝自上次调用 acceptChanges 以来对该行进行的所有更改
function createRejectChanges(target, meta) {
    return function rejectChanges() {
        if (Array.isArray(target.datas)) {
            target.datas.length = meta.original.length
            for (let i = 0; i < meta.original.length; i++) {
                const row = meta.original[i];
                
                const change = meta.changes.modified.get(row)
                if (change) {
                    // 还原修改的内容
                    Object.keys(change).forEach(el => {
                        row[el] = change[el][0]
                    })
                }
                target.datas[i] = row
            }
            initChanges(meta)
        } else {
            const change = meta.changes.modified.get(target)
            if (change) {
                // 还原修改的内容
                Object.keys(change).forEach(el => {
                    target[el] = change[el][0]
                })
            }
            meta.changes.modified.delete(target)
        }
    }
}

// 创建响应式对象
function createReactiveDataRow(target, meta) {

    // 如果对象已有代理，则返回代理
    const proxyObject = getProxy(target, meta)
    if (proxyObject) {
        return proxyObject
    }

    // 创建 proxy 的 set 处理
    const createSetter = function(meta) {
        return function set(target, property, value, receiver) {

            // 记录修改日志
            const isAdded = meta.changes.added.indexOf(target) !== -1
            // 必须是不在新增日志中的（新增的记录不需要记录修改日志），并且新旧值不相等时才记录修改日志
            if (!isAdded && target[property] !== value) {
                const change = meta.changes.modified.get(target) || {}
                if (change[property]) {
                    if (change[property][0] !== value) {
                        // 更新修改日志
                        change[property] = [ change[property][0], value ]
                    } else {
                        // 改回原值时删除改变日志
                        delete change[property]
                    }
                } else {
                    change[property] = [target[property], value]
                }

                // 存在修改时才记录
                if (Object.keys(change).length) {
                    meta.changes.modified.set(target, change)
                } else {
                    meta.changes.modified.delete(target)
                }
            }

            // 设置属性值
            return Reflect.set(target, property, value, receiver)
        }
    }

    const handlers = {
        set: createSetter(meta),
    }

    // 创建 Proxy 代理
    const observed = new Proxy(target, handlers)
    meta.toProxy.set(target, observed)
    meta.toRaw.set(observed, target)
    return observed
}

function createReactiveDataTable(target, meta) {

    // 如果对象已有代理，则返回代理
    const proxyObject = getProxy(target, meta)
    if (proxyObject) {
        return proxyObject
    }

    const createGetter = function(meta) {
        return function get(target, property /*, receiver */) {
            // 不能传递 receiver 参数，如果传入 DataTable 的 datas 用 vue 的 reactive 封装后会出现死循环，不用 reactive 则界面不刷新
            const res = Reflect.get(target, property /*, receiver */)
            if (typeof res === 'function') {
                // console.log('调用方法', property)
                switch (property) {
                    case 'push':
                        return function() {
                            meta.changes.added.push(...arguments)
                            return res.apply(target, arguments)
                        }
                    case 'unshift':
                        return function() {
                            meta.changes.added.push(...arguments)
                            return res.apply(target, arguments)
                        }
                    case 'splice':
                        return function() {
                            const delArrs = res.apply(target, arguments)
                            meta.changes.deleted.push(...delArrs)
                            return delArrs
                        }
                    case 'pop':
                    case 'shift':
                        return function() {
                            const delObj = res.apply(target, arguments)
                            meta.changes.deleted.push(delObj)
                            return delObj
                        }
                    default:
                        break;
                }
            }

            // 如果是对象，递归代理
            return isObject(res) ? createReactiveDataRow(res, meta) : res
        }
    }

    // 由于之前不知道如何捕获 push、splice、unshift、shift、pop 等方法，所以通过判断长度、索引等变化记录日志，现已通过 get 代理解决
    // const createSetter = function(meta) {
    //     return function set(target, property, value, receiver) {
    //         // 属性名是数值时，则正在执行 array[x] = xxx
    //         if (isArrayIndex(property)) {
    //             if ((target.length - 1) < property) {
    //                 // 数组的新增实质是最后一个下标+1进行赋值，所以判断不存在该下标时为新增
    //                 const res = Reflect.set(target, property, value, receiver)
    //                 if (res) {
    //                     // 需要重新获取出来，不能直接使用 value，因为新增的对象在新增后可能被转化为代理对象（例如传入的 datas 是vue的响应式对象时）
    //                     const obj = Reflect.get(target, property, receiver)
    //                     // 新增成功后记录新增日志
    //                     meta.changes.added.push(obj)
    //                 }
    //                 return res
    //             } else {
    //                 // 数组删除时，其实是从当前删除的后续所有元素往前移动，最后再删除尾部的多余元素
    //                 // 此时需要缓存所有被覆盖的元素，在设置 length 长度再判断删除了多少个，然后截取缓存中相应数量的元素来确定删除了哪些元素
    //                 if (meta.toRaw.has(value)) {
    //                     // 当 value 是代理对象时认为是在移动元素，将后面元素往前面移
    //                     if (!meta.caches.deletes) {
    //                         meta.caches.deletes = []
    //                     }
    //                     // 缓存被覆盖的记录，在改变 length 时可以取出来判断哪些记录被删除
    //                     meta.caches.deletes.push(target[property])

    //                     // 由于在移动记录时 value 也是代理对象，应该取回原对象再赋值，否则会加多一层代理
    //                     return Reflect.set(target, property, meta.toRaw.get(value), receiver)
    //                 } else {
    //                     // 当 value 是对象时认为是在给数组指定下标进行赋值操作，由于这样赋值可能导致某些字段未提供值，又或者主键不同，所以禁止该操作
    //                     // throw '不允许直接赋值整行数据，如需填入多个值可以使用 Object.assign 方法'
    //                 }
    //             }
    //         }
    
    //         switch (property) {
    //             case 'length':
    //                 if (meta.caches.deletes && target.length > value) {
    //                     // 数据原长度减去本次设置length长度，可以得到删除的个数，然后从缓存中取出相应个数得到删除的元素
    //                     // 在 createSetter 及 createDeleteProperty 会将疑似删除的元素存进缓存中
    //                     const rows = meta.caches.deletes.slice(0, target.length - value)
    //                     rows.forEach(row => {
    //                         // 清除修改日志（修改后又进行删除)
    //                         const change = meta.changes.modified.get(row)
    //                         if (change) {
    //                             // 还原修改的内容，否则记录到删除中的内容将是修改后的）
    //                             Object.keys(change).forEach(el => {
    //                                 row[el] = change[el][0]
    //                             })
    //                             meta.changes.modified.delete(row)
    //                         }
                            
    //                         const addedIndex = meta.changes.added.indexOf(row)
    //                         if (addedIndex !== -1) {
    //                             // 清除新增日志（新增后又进行删除），不需要记录
    //                             meta.changes.added.splice(addedIndex, 1)
    //                         } else {
    //                             // 保存除新增外的删除记录（新增后删除认为是未改变）
    //                             meta.changes.deleted.push(row)
    //                         }
    //                     })
    
    //                     delete meta.caches.deletes
    //                 }
    //                 break;
    //             default:
    //                 break;
    //         }
    
    //         // 设置属性值
    //         return Reflect.set(target, property, value, receiver)
    //     }
    // }

    // const createDeleteProperty = function(meta) {
    //     return function deleteProperty(target, property) {
    //         if (isArrayIndex(property)) {
    //             // 删除数组前面的元素时会将后续元素往前移，但如果只删除最后一个时，将直接删除
    //             // 所以需要将数据缓存，在设置 length 时记录删除日志
    //             if (!meta.caches.deletes) {
    //                 meta.caches.deletes = []
    //             }
    //             meta.caches.deletes.push(target[property])
    //         }
    //         return true
    //     }
    // }

    const handlers = {
        get: createGetter(meta),
        // set: createSetter(meta),
        // deleteProperty: createDeleteProperty(meta)
    }

    // 创建 Proxy 代理
    const observed = new Proxy(target, handlers)
    meta.toProxy.set(target, observed)
    meta.toRaw.set(observed, target)
    return observed
}

function createReactiveDataSource(target, meta) {

    const createGetter = function(meta) {
        return function get(target, property, receiver) {

            switch (property) {
                case 'clear':
                    return createClear(target, meta)
                case 'loadDatas':
                    return createLoadDatas(target, meta)
                case 'getOriginal':
                    return createGetOriginal(meta)
                case 'getChanges':
                    return createGetChanges(meta)
                case 'acceptChanges':
                    return createAcceptChanges(target, meta)
                case 'rejectChanges':
                    return createRejectChanges(target, meta)
                case 'datas': {
                    const datas = Reflect.get(target, property, receiver)
                    return createReactiveDataTable(datas, meta)
                }
                default:
                    break;
            }
            
            return Reflect.get(target, property, receiver)
        }
    }

    const createSetter = function() {
        return function set(target, property, value, receiver) {
            switch (property) {
                case 'datas':
                    throw '不允许直接赋值 datas 属性，如需填入多行数据请使用 datas.push(...) 方法'
                default:
                    break;
            }

            // 设置属性值
            return Reflect.set(target, property, value, receiver)
        }
    }

    const handlers = {
        get: createGetter(meta),
        set: createSetter(/*meta*/)
    }

    return new Proxy(target, handlers)
}

export function ProxyChanges(target, options) {

    // 为空时初始化默认值
    target = target || {}
    if (!target.datas) {
        target.datas = []
    }

    // 检查参数
    if (!Array.isArray(target.datas)) {
        throw '参数 target 的 datas 属性类型必须是数组'
    }

    const meta = {
        // 选项
        options: options,
        // 原始数组的一份引用，用于撤消时回滚（只是原数组的一份引用，不是深复制，为了保留原数组元素的位置）
        original: target.datas.slice(0),
        // 已代理的 DataRow 集合（key:原始对象，value:代理对象），用于解决重复代理
        toProxy: new WeakMap(),
        // 已代理的 DataRow 集合（key:代理对象，value:原始对象），与 toProxy 相反
        toRaw: new WeakMap(),
        // 变更日志，不分解到每行每个字段是因为方便传递，由一个数据源传到另一个数据源
        changes: {
            added: [],
            deleted: [],
            modified: new WeakMap()
        },
        // // 缓存（用于记录临时数据）
        // caches: {
        //     // 由于删除时涉及多个方法，所以需要缓存临时存储被删除的元素
        //     deletes: []
        // }
    }

    return createReactiveDataSource(target, meta)
}